import React from "react"
import styled from "styled-components"

const ColorWrapper = styled.g`
  .st3 {
    fill: none;
    stroke: #fff;
  }
  .st4 {
    fill: #f05b5b;
  }
  .st6,
  .st7 {
    stroke: #000;
  }
  .st7 {
    fill: #fff;
  }
  .st10 {
    stroke: #fff;
    stroke-width: 3;
  }
  .st10,
  .st11,
  .st13,
  .st14 {
    fill: none;
  }
  .st11 {
    stroke-width: 5;
    stroke: #fff;
  }
  .st13,
  .st14 {
    stroke: #000;
  }
  .st14 {
    stroke-width: 2;
  }

  text {
    fill: #fff;
    font-size: 3rem;
  }
`

const ColorIcon = () => (
  <ColorWrapper>
    <circle className="icon-bg" cx="150" cy="150" r="150" />
    <g id="grapes_2_">
      <path
        fill="#5b90d9"
        stroke="#fff"
        d="M156.3 95.6c-5.44 2.47-8.55 8.24-6.93 12.88.71 2.05 2.22 3.53 4.16 4.34-.59.17-1.17.39-1.75.65-5.44 2.47-8.55 8.24-6.93 12.88.43 1.23 1.15 2.26 2.07 3.06-.9.18-1.81.47-2.72.88-5.44 2.47-8.55 8.24-6.93 12.88.25.72.61 1.39 1.05 1.97-5.27 2.53-8.26 8.18-6.67 12.75.25.72.61 1.39 1.05 1.97-5.27 2.53-8.26 8.18-6.67 12.75 1.62 4.64 7.35 6.39 12.78 3.92 2.49-1.13 4.51-2.98 5.79-5.09 2.58 1.74 6.36 2 10.02.33 2.17-.99 3.97-2.5 5.23-4.25 1.98.28 4.19-.03 6.36-1.02.72-.33 1.4-.71 2.04-1.15.01.84.15 1.66.43 2.46 1.62 4.64 7.35 6.39 12.78 3.92 4.84-2.2 7.84-7.01 7.29-11.31 1.26-.12 2.56-.47 3.85-1.06 5.44-2.47 8.55-8.24 6.93-12.88-.91-2.63-3.15-4.33-5.9-4.86 4.1-2.84 6.23-7.69 4.83-11.69-1.15-3.29-4.35-5.12-8.07-5.03 1.39-2.42 1.84-5.14.99-7.57-1.59-4.57-7.16-6.33-12.51-4.03-.03-.77-.17-1.53-.42-2.25-1.34-3.83-5.48-5.7-9.95-4.83 1.04-2.19 1.3-4.57.55-6.71-1.58-4.64-7.31-6.39-12.75-3.91z"
      />
      <path
        d="M180.55 136.27c5.37-.01.48 16.81-10.71 9.74M175.34 118.68c4.25-4.88 13.97 8.58-.63 14.96M211.62 113.62s-12.2-4.18-20.02 4.24"
        className="st3"
      />
    </g>
    <g id="apple_1_">
      <path
        d="M93.92 76.43c12.26 10.08 28.8 10.23 36.94.33 6.1-7.42 5.75-18.39.02-27.67-1.91-3.09-4.42-5.99-7.47-8.48-2.2-1.8-4.6-3.03-7.13-3.8-10.49-2.54-22.6.02-30.13 8.03-1.59 2.16-2.61 4.68-3.1 7.34-.98 5.32.21 11.19 3.43 15.81 1.87 3.02 4.37 5.91 7.44 8.44z"
        className="st4"
      />
      <path
        d="M79.46 91.74c12.26 10.08 28.8 10.23 36.94.33 6.1-7.42 5.75-18.39.02-27.67-1.91-3.09-4.42-5.99-7.47-8.48-2.2-1.8-4.6-3.03-7.13-3.8-10.49-2.54-22.6.02-30.13 8.03-1.59 2.16-2.61 4.68-3.1 7.34-.98 5.32.21 11.19 3.43 15.81 1.86 3.02 4.37 5.92 7.44 8.44z"
        className="st4"
      />
      <path
        fill="none"
        stroke="#c7b299"
        strokeWidth="3"
        d="M67.69 45.81c6.17.67 11.95 3.54 17.38 6.91"
      />
      <path
        d="M101.22 87.68c5.85-18.84 21.28-20.85 21.28-20.85l-21.28 20.85z"
        className="st6"
      />
      <path
        d="M96.45 59.7c4.86 3.68 6.03 10.38 2.48 14.68-3.54 4.3-10.5 4.46-15.47.55-4.85-3.68-5.71-9.82-2.03-13.87s10.34-4.75 15.02-1.36z"
        className="st7"
      />
      <path
        d="M96.39 62.95c4.1 3.2 9.46 3.6 11.89.65s1.01-8.08-3-11.08c-3.7-2.5-8.53-2.06-11.1.66-2.57 2.71-1.68 6.97 2.21 9.77z"
        className="st7"
      />
      <path d="M95.05 67.17c1.65.86 2.83 2.46 1.61 3.96-2.15 2.61-7.68-1.31-6.21-4.28.9-.99 2.95-.87 4.6.32zM105.54 58.44c1.61.94 2.79 2.54 1.57 4.03-1.91 1.56-7.55.05-6.03-4.13.9-.99 2.86-.98 4.46.1z" />
      <path
        fill="#00ce00"
        d="M85.29 53.51c-3.53-.31-7.01-1.51-10.55-1.22-3.6.3-7.03 2.23-9.14 5.16-1.34 1.86-2.15 5.27-2.28 7.56 8.04-1.2 16.74-5.27 21.97-11.5z"
      />
    </g>
    <path
      fill="#6ab063"
      d="M108.3 92.23c-28.86 13.6-18.16 32.58-10.18 41.47-4.81 8.59 9.6 32.15 38.46 18.55 15.67-13.71 13.96-26.57 26.14-33.69 12.17-7.12 22.76-16.86 19.23-24.36-3.63-7.7-14.96-4.24-32.37-.39-15.31 3.89-10.51-4.7-41.28-1.58z"
    />
    <path
      d="M153.86 104.97c-3.75 3.28-9.24 3.2-12.02-.25-2.78-3.44-1.7-8.96 2.25-12.28 3.75-3.27 8.74-3.03 11.29.48 2.57 3.51 1.96 8.86-1.52 12.05z"
      className="st7"
    />
    <path d="M146.73 100.76c-1.8 2.18-4.53 3.47-6.32 1.25-3.14-3.88 4.4-10.9 8.29-7.91 1.15 1.6.3 4.56-1.97 6.66z" />
    <path
      d="M167.53 120.74c-3.75 3.28-9.24 3.2-12.02-.25-2.78-3.44-1.7-8.96 2.25-12.28 3.75-3.27 8.74-3.03 11.29.48 2.57 3.51 1.96 8.86-1.52 12.05z"
      className="st7"
    />
    <path d="M160.4 114.43c-1.8 2.18-4.53 3.47-6.32 1.25-3.14-3.88 4.4-10.9 8.29-7.91 1.15 1.6.3 4.56-1.97 6.66z" />
    <path
      d="M126.44 113.73c14.82 2.45 11.32 16.66 11.32 16.66l-11.32-16.66z"
      className="st6"
    />
    <g id="blenderbody_1_">
      <g id="base_1_">
        <path
          d="M99.36 283.91c33.46 2.04 66.91 2.04 100.37 0 2.35 0 4.25-1.9 4.25-4.25 3.93-9.29-102.42-2.13-104.62-4.26-5.49-.08-5.54 8.59 0 8.51z"
          className="st10"
        />
        <path
          d="M90 275.4c37.99 1.74 75.99 1.74 113.98 0 5.83-.03 5.84-14.14 0-14.18 0 0-7.66 7.37-57.84 6.52-56.87 1.13-56.87-13.93-60.39-.62-.4 3.37.87 8.43 4.25 8.28z"
          className="st10"
        />
      </g>
      <path
        d="M197.42 227.89c10.87 4.47 21.43 9.71 31.57 15.65-5.43 6.36-12.6 13.14-18.03 19.49 2.79 2.6 7.35 2.41 7.35 2.41M102.14 223.86c-11.16 3.68-22.07 8.14-32.61 13.34 4.96 6.73 11.62 14.01 16.58 20.74-2.97 2.4-7.51 1.88-7.51 1.88"
        className="st11"
      />
    </g>
    <g id="pitcher_1_">
      <path
        d="M230.72 149.62c13.39-28.88 47.85-91.55-10.88-75.07l-5.1 4.72s1.12 7.5 1.7 9.44c37.73-32.25 11.66 53.82-1.7 59.73-2.5 1.11-14.22 2.25-15 3.39-1.9 2.74-4.2 9.58-4.2 9.58 6.47-8.8 23.48-3.68 35.18-11.79zM109.56 182.64c13.22.64 80.16 5.3 83.36-3.54 0-1.96-2.29-3.54-5.1-3.54-26.36 1.09-52.45 1.11-78.26 0-6.59-.07-6.63 7.14 0 7.08z"
        className="st10"
      />
      <path
        d="M109.56 175.56l78.26 1.18c16.6-32.19 26.99-64.41 28.92-96.69 0 2.56-124.19 2.36-139.5 0-15.31-1.18 6.89 9.57 7.44 15.24 1.83 19.1 15.36 59.26 24.88 80.27zM119.77 166.13c-7.91-12.35-21.01-49.99-22.12-64.86M96.8 101.27h21.27M99.1 113.18h10.46M102.8 122.61h10.46M106.06 132.05h8.5M109.76 141.48h10.46M112.86 148.56h6.81M116.56 157.99h15.31M120.77 166.24h10.46"
        className="st10"
      />
    </g>
    <g id="top_1_">
      <path
        d="M137.54 37.42L172 51.82c6.25 3.11 8.14 1.19 7.11-2.66 2.47-10.44-28.98-18.93-37.56-21.32-2.82-1.18-6 .01-7.11 2.66-4.43 1.72-2.45 4.99 3.1 6.92z"
        className="st10"
      />
      <path
        d="M211.1 75.43c5.44-8.2-117.35-59.75-120.17-50.21-52.39-9.7 140.58 74.06 120.17 50.21z"
        className="st10"
      />
    </g>
    <path
      id="faceback_1_"
      fill="#fff"
      stroke="#fff"
      d="M96.93 265.92c13.78-.81 109.64 8.56 108.88-6.8l-4.03-33.84-11.29-35.92c0-3.76-3.05-6.8-6.8-6.8h-69.75c-3.76 0-6.8 3.05-6.8 6.8l-11.91 34.88-5.1 34.88c0 3.75 3.04 6.8 6.8 6.8z"
    />
    <g id="blenderface_1_">
      <path
        d="M127.36 223.26c-1.84 18.59 15.42 20.15 16.94 1.53 1.84-18.58-15.41-20.14-16.94-1.53zM161.34 222.86c-1.84 18.59 15.42 20.15 16.94 1.53 1.84-18.58-15.41-20.14-16.94-1.53z"
        className="st13"
      />
      <path
        d="M140.45 215.76c-.42 5.5-9.05 4.72-8.47-.77.21-2.34-3.99-8.77-3.99-8.77s12.67 7.2 12.46 9.54zM174.49 214.05c-.42 5.5-9.05 4.72-8.47-.77.21-2.34 4.62-11.23 4.62-11.23s4.07 9.66 3.85 12z"
        className="st6"
      />
      <path
        d="M125.06 205.38c.74.82 1.47 1.64 2.21 2.46M136.07 201.71c.08 1.15.15 2.3.23 3.45M147.22 207.89c-.58.82-1.15 1.64-1.73 2.45M158.5 209.31c1.22.32 2.3 1.15 2.93 2.25M168.07 203.19c.16 1.15.33 2.3.49 3.44M180.88 208.6c-.82.66-1.64 1.31-2.46 1.97"
        className="st13"
      />
      <path
        d="M159.04 194.98c7.85-6.83 16.3-6.07 22.53-.25M146.38 194.93c-7.47-5.8-15.86-6.4-22.96-.11"
        className="st14"
      />
      <path
        fill="#c1272d"
        d="M171.34 248.67s5.36-14.35-2.76-11.93c-7.41 2.21-12.06 16.35-12.06 16.35l14.82-4.42z"
      />
      <path
        d="M162.06 251.62c3.41-1.57 4.84-6.18 6.06-9.9M135.84 241.31c-2.91.14-5.43 2.89-5.33 5.8M176.15 241.31c2.91.14 5.43 2.89 5.33 5.8"
        className="st13"
      />
      <path
        d="M135.19 246.34c5.52 5.24 12.93 7.18 19.99 6.56 7.06-.62 13.84-3.6 20.18-7.33"
        className="st13"
      />
    </g>
  </ColorWrapper>
)

export default ColorIcon
